import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  text-decoration: none;
  display: block;
  font-size: 14px;
  background: ${({ theme }) => theme.colors.colorWhite};
  padding: 10px 15px;
  margin-bottom: 1px;
  line-height: 1.5em;
  &:link,
  &:visited,
  &:active {
    color: ${({ theme }) => theme.colors.colorGreyDark};
  }
  &:hover {
    color: ${({ theme }) => theme.hoverColors.colorBlue};
  }
  ${({
    active,
    theme,
  }) => {
    if (active) {
      return `
        &:link,
        &:visited,
        &:active {
          color: ${theme.colors.colorBlue};
          font-weight: bold;
        }
      `;
    }
    return '';
  }}
  ${({ main }) => main && 'font-weight: bold;'}
`;

export default ({
  to,
  title,
  active,
  main,
}) => (
  <StyledLink to={to} active={active} main={main}>
    {title}
  </StyledLink>
);
